import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/app/landing_pages/karma/Common/MainUi.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/app/landing_pages/karma/Components/RelatedPosts.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/app/landing_pages/karma/Components/UI/TextArticle.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/components/UI/karma/PoemAudioVideo.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/components/UI/Subscribe/SubscribeBoxV2.js");
